export const CUSTOM_CSS_PREVIEW_SESSION_MARKER = 'sp-css-preview-active'
export const CUSTOM_CSS_PREVIEW_QUERY_PARAM = 'cssPreview'
export const CUSTOM_CSS_PREVIEW_QUERY_PARAM_VALUE = '1'
export const VALIDATE_CSS_URL = '/services/api/validateCss'

export const getCustomCssPreviewChannelName = (portalSubdomain: string): string => `sp-css-preview-${portalSubdomain}`

export const getCustomCssPreviewStorageKey = (portalSubdomain: string): string => `sp-css-preview-draft-${portalSubdomain}`
